import Vue from 'vue'
import MyConfirm from '@/components/promptbox/MyConfirm.vue'

const ConfirmBox = Vue.extend(MyConfirm);
MyConfirm.install = (content, title, options) => {
	if (typeof title === 'object') {
		options = title;
		title = '系统提示';
	} else if (title === undefined) {
		title = '系统提示';
	}

	options = Object.assign({
		title: title,
		content: content,
	}, options);

	let instance = new ConfirmBox({
		data: options
	}).$mount();

	document.body.appendChild(instance.$el);

	return instance.confirm();
};
// type 值
// <!-- 问号 question-->
// <!-- 警告 warning -->
// <!-- 操作成功 success-->
// <!-- 提示 tips-->

//页面调用
// show(){
//     this.$my_confirm('是否登录?',{
//         yesBtnText:'登录',
//     }).then(() => {
//         //点登录
//     }).catch(() => {
//         //点取消
//     });
// },
// show1(){
//     this.$my_confirm('此操作将永久删除该文件, 是否继续？','提示',{
//         yesBtnText:'是',
//         cancelBtnText:'否',
//         type: 'warning'，
//       isShowCancelBtn: true //是否显示取消按钮
//     }).then(() => {
//         //点是
//     }).catch(() => {
//         //点否
//     });
// },
export default MyConfirm
